import { useEffect, useRef, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
  const [enabled, setEnabled] = useState(false);
  const [hovering, setHovering] = useState(false);
  const x = useMotionValue(-200);
  const y = useMotionValue(-200);
  const sx = useSpring(x, { stiffness: 350, damping: 35, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 350, damping: 35, mass: 0.4 });

  const glowX = useSpring(x, { stiffness: 60, damping: 25 });
  const glowY = useSpring(y, { stiffness: 60, damping: 25 });

  const lastTarget = useRef(null);

  useEffect(() => {
    const can = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (!can) return;
    setEnabled(true);
    document.documentElement.classList.add("has-custom-cursor");

    const onMove = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const target = e.target;
      if (target !== lastTarget.current) {
        lastTarget.current = target;
        const interactive = target.closest(
          "a, button, [data-cursor='hover'], input, textarea, select"
        );
        setHovering(Boolean(interactive));
      }
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    return () => {
      window.removeEventListener("mousemove", onMove);
      document.documentElement.classList.remove("has-custom-cursor");
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <>
      {/* Big soft orange glow following cursor */}
      <motion.div
        aria-hidden
        className="pointer-events-none fixed z-[1] -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{
          x: glowX,
          y: glowY,
          width: 520,
          height: 520,
          background:
            "radial-gradient(circle, rgba(201,106,43,0.18) 0%, rgba(201,106,43,0) 60%)",
          filter: "blur(20px)",
        }}
      />
      {/* Outer ring */}
      <motion.div
        aria-hidden
        className="pointer-events-none fixed z-[80] -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#C96A2B]/70 mix-blend-difference"
        style={{
          x: sx,
          y: sy,
          width: hovering ? 56 : 36,
          height: hovering ? 56 : 36,
        }}
        transition={{ type: "spring", stiffness: 200, damping: 25 }}
      />
      {/* Dot */}
      <motion.div
        aria-hidden
        className="pointer-events-none fixed z-[81] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#C96A2B]"
        style={{
          x,
          y,
          width: hovering ? 4 : 6,
          height: hovering ? 4 : 6,
        }}
      />
    </>
  );
}
